import Vue from 'vue';
import Router from 'vue-router';
import firebase from 'firebase';
import Userauth from '../auth/js/index';

import Body from '../components/body';
import Auth from '../auth/auth';

/* Auth */
import login from '../auth/login';
import google2FA from '../auth/google-2fa';
import ForgotPassword from '../auth/forgot-password';
import callback from '../pages/callback';
import Register from '../auth/register';

/* Drivers */
import Drivers from '../pages/drivers/driverslist/driverslist.vue';

/* Driver-Profile */
import DriverProfile from '../pages/drivers/driverprofile/driverprofile.vue';

/* Driver-Add */
import DriverAdd from '../pages/drivers/adddriver/adddriver.vue';

/* FAQ */
import Faq from '../pages/faq';

/* Support Ticket */
import Support from '../pages/support';

/* maintenance */
import Maintenance from '../pages/maintenance';

/* Error Pages */
import Error400 from '../errors/error_400';
import Error401 from '../errors/error_401';
import Error403 from '../errors/error_403';
import Error404 from '../errors/error_404';
import Error500 from '../errors/error_500';
import Error503 from '../errors/error_503';

/* comingsoon */
import ComingsoonSimple from '../pages/comingsoon/comingsoon_simple';
import ComingsoonImage from '../pages/comingsoon/comingsoon_image';
import ComingsoonVideo from '../pages/comingsoon/comingsoon_video';

/* Dashboards */
import Default from '../pages/dashboard/default';
import Ecommerce from '../pages/dashboard/ecommerce';
import Home from '../pages/dashboard/home/home';

/* Widgets */
import GeneralWidgets from '../pages/widgets/general_widgets';
import ChartWidgets from '../pages/widgets/chart_widgets';

/* projects */
import projectlist from '../pages/project/project-list';
import createproject from '../pages/project/create-project';

/* uikits */
import alert from '../pages/uikits/alert';
import Helperclasses from '../pages/uikits/helper_classes';
import Avatars from '../pages/uikits/avatars';
import Grid from '../pages/uikits/grid';
import Tagpills from '../pages/uikits/tag_pills';
import Typography from '../pages/uikits/typography';
import Progressbar from '../pages/uikits/progress_bar';
import Modal from '../pages/uikits/modal';
import Popover from '../pages/uikits/popover';
import Tooltip from '../pages/uikits/tooltip';
import Spinners from '../pages/uikits/loader';
import Dropdown from '../pages/uikits/dropdown';
import Accordion from '../pages/uikits/accordion';
import Boxshadow from '../pages/uikits/box_shadow';
import Lists from '../pages/uikits/lists';
/* advance */
import Scrollable from '../pages/advance/scrollable';
import Sweetalert from '../pages/advance/sweetalert';
import Tree from '../pages/advance/tree';
import Rating from '../pages/advance/rating';
import Pagination from '../pages/advance/pagination';
import Ribbons from '../pages/advance/ribbons';
import Tour from '../pages/advance/tour';
import Rangeslider from '../pages/advance/range_slider';
import Breadcrumb from '../pages/advance/breadcrumb';
import Upload from '../pages/advance/upload';
import Sticky from '../pages/advance/sticky';
import Toastr from '../pages/advance/toastr';
import ImageCropper from '../pages/advance/image_cropper';
import Draganddrop from '../pages/advance/draganddrop';
/* charts */
import GoogleChart from '../pages/charts/google_chart';
// import Chartjs from '../pages/charts/chartjs';
import Chartist from '../pages/charts/chartist';
import ApexChart from '../pages/charts/apexchart';
/* icons */
import Flag from '../pages/icons/flag';
import Ico from '../pages/icons/ico_icon';
import Themify from '../pages/icons/themify_icon';
import Fontawesome from '../pages/icons/font_awesome';
import FeatherIcon from '../pages/icons/feather_icon';
import WhetherIcon from '../pages/icons/weather';

/* Buttons */
import Default_buttons from '../pages/buttons/default_buttons';
import Flat_buttons from '../pages/buttons/flat_buttons';
import Edge_buttons from '../pages/buttons/edge_buttons';
import Raised_buttons from '../pages/buttons/raised_buttons';
import Group_buttons from '../pages/buttons/group_buttons';
/* Form */
import FormWizrd from '../pages/forms/form_wizard';
import FormValidation from '../pages/forms/form_validation';
import FormBaseInputs from '../pages/forms/form_base_inputs';
import FormCheckboxRadio from '../pages/forms/form_checkbox_radio';
import FormInputGroups from '../pages/forms/form_input_groups';
import FormMegaOptions from '../pages/forms/form_mega_options';
/* Form Widgets */
import FormDatepicker from '../pages/form_widgets/datepicker';
import FormSelect2 from '../pages/form_widgets/select2';
import FormSwitch from '../pages/form_widgets/switch';
import FormTypeahead from '../pages/form_widgets/typeahead';
import FormClipboard from '../pages/form_widgets/clipboard';
import FormTouchspin from '../pages/form_widgets/touchspin';
/* E-Commerce */
import Products from '../pages/ecommerce/products';
import ProductDetails from '../pages/ecommerce/product_details';
import Cart from '../pages/ecommerce/cart';
import Wishlist from '../pages/ecommerce/wishlist';
import Checkout from '../pages/ecommerce/checkout';
import Invoice from '../pages/ecommerce/invoice';
import Success from '../pages/ecommerce/success';
import OrderHistory from '../pages/ecommerce/order_history';
import PaymentDetails from '../pages/ecommerce/payment_details';
/* Chat */
import Chat from '../pages/chat/chat';
import Videochat from '../pages/chat/videochat';
/* Email  */
import Email from '../pages/email/app';
/* File Manager  */
import FileManager from '../pages/filemanager';
/* Kanban board */
import Kanban from '../pages/kanban';
/* Cards */
import Basic from '../pages/cards/basic';
import Creative from '../pages/cards/creative';
import Tabbed from '../pages/cards/tabbed';
import Draggable from '../pages/cards/draggable';

/* pricing */
import Pricing from '../pages/pricing/pricing';
/* sample page */
import SamplePage from '../pages/sample_page';
import Todo from '../pages/todo/todo';
import FirebaseTodo from '../pages/todo/firebase_todo';
/* bootstrap tables */
import BootstrapBasic from '../pages/tables/bootstrap/basic';
import BootstrapSizing from '../pages/tables/bootstrap/sizing';
import BootstrapBorder from '../pages/tables/bootstrap/border';
import BootstrapStyling from '../pages/tables/bootstrap/styling';
/* datatable tables */
import DatatableBasic from '../pages/tables/datatable/basic_init';
import DatatableSelectDelete from '../pages/tables/datatable/select_delete';
import FilterTable from '../pages/tables/datatable/filter';
import DatatableExport from '../pages/tables/datatable/data_export';
/* Bookmark */
import Bookmark from '../pages/bookmark';
/* calendar */
import Calendar from '../pages/calendar/fullcalendar';
/* Timeline */
import TimelineOne from '../pages/timeline/timeline_one';

/* vuejs smart table */
import SmartTable from '../pages/tables/vuejs_smart_table/basic';

/* Editor */
import SimpleEditor from '../pages/editor/simple_editor';
import CkEditor from '../pages/editor/ckeditor.vue';


/* User Profile */
import UserProfile from '../pages/users/profile';
import UserEditProfile from '../pages/users/edit-profile';
import UserCards from '../pages/users/cards';

/* Blogs */
import Blog from '../pages/blogs/blog';
import BlogSingle from '../pages/blogs/blog_single';

/* Maps */
import GoogleMaps from '../pages/maps/vue_google_maps';
import VueLeaflet from '../pages/maps/vue_leaflet';

/* Job Search */
import JobList from '../pages/job/job_list';
import JobDetails from '../pages/job/job_details';
import JobApply from '../pages/job/job_apply';

/* Search */
import Search from '../pages/search';

/* Social App */
import Social from '../pages/social_app';

/* Authentication */
import LoginOne from '../pages/authentication/login_one';
import LoginTwo from '../pages/authentication/login_two';
import LoginValidate from '../pages/authentication/login_with_validation';
import RegisterImage from '../pages/authentication/register_image';
import RegisterImage2 from '../pages/authentication/register_image2';
import Unlock from '../pages/authentication/unlock';
import ForgetPassword from '../pages/authentication/forget_password';
import ResetPassword from '../pages/authentication/reset_password';

/* Learning */
import Learninglist from '../pages/learning/learninglist';
import Coursedetailed from '../pages/learning/coursedetailed';

/* knowledgebase */
import Knowledgebase from '../pages/knowledgebase/knowledgebase';

// Gallery
import GridGallery from '../pages/gallery/grid-gallery';
import GridGalleryDesc from '../pages/gallery/gallery-desc';
import GalleryMasonary from '../pages/gallery/masonary-gallery';
import GalleryMasonaryDesc from '../pages/gallery/masonary-desc';
import HoverEffect from '../pages/gallery/hover-effect';

/* Trailers */
import Trailers from '../pages/trailers/trailerslist/trailerslist.vue';
import TrailerAdd from '../pages/trailers/addtrailer/addtrailer.vue';
import TrailerProfile from '../pages/trailers/trailerprofile/trailerprofile.vue';

/* Vehicles */
import Vehicles from '../pages/vehicles/vehicleslist/vehicleslist.vue';
import VehicleProfile from '../pages/vehicles/vehicleprofile/vehicleprofile.vue';
import VehicleAdd from '../pages/vehicles/addvehicle/addvehicle.vue';
import VehicleProfileChecks from '../pages/vehicles/vehicleprofilechecks/vehicleprofilechecks.vue';

// component
import VehicleChecks from '../pages/vehiclechecks/vehiclechecks/vehiclechecks';
import VehicleCheckView from '../pages/vehiclechecks/vehiclecheckview/vehiclecheckview';
import Documents from '../pages/documents/documents/documents';
import Settings from '../pages/settings/settings/settings';
import CompanyCheckSetting from '../pages/settings/companychecksetting/companychecksetting';
import CompanyCheckTemplates from '../pages/settings/companychecksetting/companychecktemplates/companychecktemplates.vue';
import CompanyCheckTemplateChecks from '../pages/settings/companychecksetting/companychecktemplatechecks/companychecktemplatechecks.vue';
import AddCompanyCheckTemplate from '../pages/settings/companychecksetting/addcompanychecktemplate/addcompanychecktemplate.vue';
import CompanyInspectionsSetting from '../pages/settings/companyinspectionsetting/companyinspectionsetting';
import ImportExcel from '../pages/settings/importexcel/importexcel';

// vehicle inspections
import VehicleInspections from '../pages/vehicleinspections/vehicleinspections/vehicleinspections';
import VehicleInspectionView from '../pages/vehicleinspections/vehicleinspectionview/vehicleinspectionview';
import VehicleInspectionCreate from '../pages/vehicleinspections/vehicleinspectioncreate/vehicleinspectioncreate';
import VehicleInspectionEdit from '../pages/vehicleinspections/vehicleinspectionedit/vehicleinspectionedit';

/* External Links */
import ExternalLinks from '../pages/externallinks/externallinks';

/* Branches */
import Branches from '../pages/branches/brancheslist/brancheslist.vue';
import BranchAdd from '../pages/branches/addbranch/addbranch.vue';
import BranchUpdate from '../pages/branches/editbranch/editbranch.vue';

/* Audit Log */
import AudigtLog from '../pages/auditlog/auditlog';

/* Reports */
import Reports from '../pages/reports/reports';

/* Fuel */
import Fuel from '../pages/fuel/fuel';


/* Assets */
import AssetsAdd from '../pages/assets/assetsadd/assetsadd';
import Category from '../pages/assets/category/category';
import Location from '../pages/assets/location/location';
import Group from '../pages/assets/group/group';
import Ownership from '../pages/assets/ownership/ownership';
import AssetsList from '../pages/assets/assets-list/assetslist.vue';
import AssetProfile from '../pages/assets/assetprofile/assetprofile.vue';
import PrintQrCode from '../pages/assets/printqrcode/printqrcode.vue';
import AssetTemplates from '../pages/assets/assettemplates/assettemplates.vue';
import AssetTemplateChecks from '../pages/assets/assettemplatechecks/assettemplatechecks.vue';
import AddAssetTemplate from '../pages/assets/addassettemplate/addassettemplate.vue';
import AssetChecks from '../pages/assetchecks/assetchecks/assetchecks';
import AssetCheckView from '../pages/assetchecks/assetcheckview/assetcheckview';
import PrintGroupQrCode from '../pages/assets/group/printqrcode.vue';

/* Users */
import Users from '../pages/users/userslist/user.vue';
import UserAdd from '../pages/users/adduser/adduser.vue';
import UserUpdate from '../pages/users/edituser/edituser.vue';
import ViewAccountPermissions from '../pages/users/view-account-permissions/view-account-permissions.vue';


import ProfileUpdate from '../pages/profile/update.vue';

/* Account Roles */
import AccountRoles from '../pages/account-roles/roleslist/roleslist.vue';
import AccountRoleAdd from '../pages/account-roles/addrole/addrole.vue';
import AccountRoleEdit from '../pages/account-roles/editrole/editrole.vue';
import AccountRoleView from '../pages/account-roles/viewrole/viewrole.vue';
import CompanyDetails from '../pages/company/update.vue';
import ReportsTable from '../pages/reports-table/reports.vue';
import Groups from '../pages/groups/groups.vue';
import PrintGroupQr from '../pages/groups/printgroupqrcode.vue';

import EmailPreferences from '../pages/email-preferences/emailpreferences.vue';

import TaskAdd from '../pages/task/addtask/addtask.vue';
import BookRepair from '../pages/task/bookrepair/bookrepair.vue';
import BookServiceAppointment from '../pages/task/bookserviceappointment/bookserviceappointment.vue';


import AssetSettings from '../pages/assets/settings/settings';

Vue.use(Router);

const routes = [
{ path: '', redirect: { name: 'home' } },
{
  path: '/dashboard',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'home',
    name: 'home',
    component: Home,
    meta: {
      title: 'Dashboard',
    }
  }, 
  {
    path: 'default',
    name: 'default',
    component: Default,
    meta: {
      title: 'Dashboard',
    }
  },
  {
    path: 'ecommerce',
    name: 'ecommerce',
    component: Ecommerce,
    meta: {
      title: 'Ecommerce Dashboard',
    }
  }
  ]
},

{
    path: '/vehicle-checks/:VehicleClassID',
    component: Body,
    children: [
  	{
	    path: '',
	    name: 'VehicleChecks',
	    component: VehicleChecks,
	    meta: {
	      title: 'Vehicle Checks',
	    }
  	}
  ]
},
{
    path: '/vehicle-inspections/:VehicleClassID',
    component: Body,
    children: [
  	{
	    path: '',
	    name: 'VehicleInspections',
	    component: VehicleInspections,
	    meta: {
	      title: 'Vehicle Inspections',
	    }
  	}
  ]
},
{
  path: '/create-vehicle-inspection/:UniqueId',
  component: VehicleInspectionCreate,
  children: [
  {
    path: '',
    name: 'VehicleInspectionCreate',
    component: VehicleInspectionCreate,
    meta: {
      title: 'Create Vehicle Inspection',
    }
  }
]
},
{
  path: '/edit-vehicle-inspection/:InspectionId/:UniqueId',
  component: VehicleInspectionEdit,
  children: [
  {
    path: '',
    name: 'VehicleInspectionEdit',
    component: VehicleInspectionEdit,
    meta: {
      title: 'Edit Vehicle Inspection',
    }
  }
]
},
{
    path: '/vehicle-inspection-view/:Id',
    component: VehicleInspectionView,
    children: [
  	{
	    path: '',
	    name: 'VehicleInspectionView',
	    component: VehicleInspectionView,
	    meta: {
	      title: 'Vehicle Inspection Check',
	    }
  	}
  ]
},
{
  path: '/vehicle-check-view/:Id',
  component: VehicleCheckView,
  name: VehicleCheckView,
  meta: {
    title: 'Vehicle Check View',
  }
},
{
  path: '/asset-checks/:AssetTemplateID',
  component: Body,
  children: [
  {
    path: '',
    name: 'AssetChecks',
    component: AssetChecks,
    meta: {
      title: 'Asset Checks',
    }
  }
]
},
{
  path: '/asset-check-view/:Id',
  component: AssetCheckView,
  name: AssetCheckView,
  meta: {
    title: 'Asset Check View',
  }
},
{
    path: '/documents',
    component: Body,
    children: [
  	{
	    path: '',
	    name: 'Documents',
	    component: Documents,
	    meta: {
	      title: 'Documents',
	    }
  	}
  ]
},
{
    path: '/reports',
    component: Body,
    children: [
  	{
	    path: '',
	    name: 'Reports',
	    component: Reports,
	    meta: {
	      title: 'Reports',
	    }
  	}
  ]
},
{
    path: '/reports-table',
    component: Body,
    children: [
  	{
	    path: '',
	    name: 'Reports Table',
	    component: ReportsTable,
	    meta: {
	      title: 'Reports Table',
	    }
  	}
  ]
},
{
  path: '/fuel',
  component: Body,
  children: [
  {
    path: '',
    name: 'Fuel',
    component: Fuel,
    meta: {
      title: 'Fuel',
    }
  }
]
},
{
    path: '/auditlog',
    component: Body,
    children: [
  	{
	    path: '',
	    name: 'AudigtLog',
	    component: AudigtLog,
	    meta: {
	      title: 'Audit Log',
	    }
  	}
  ]
},
{
    path: '/settings',
    component: Body,
    children: [
    {
	    path: 'company-check-setting',
	    name: 'CompanyCheckSetting',
	    component: CompanyCheckSetting,
	    meta: {
	      title: 'CompanyCheckSetting',
	    },	   
  	},
  	{
		path:'company-check/templates/:ClassId',
		name:'CompanyCheckTemplates',
		component:CompanyCheckTemplates,
		meta: {
			title: 'Company Check Templates',
		}
    },    
    {
		path:'company-check/template/checks/:TemplateId',
		name:'CompanyCheckTemplateChecks',
		component:CompanyCheckTemplateChecks,
		meta: {
			title: 'Company Check Template Checks',
		}
    },
    {
		path:'company-check/template/add/:ClassId',
		name:'AddCompanyCheckTemplate',
		component:AddCompanyCheckTemplate,
		meta: {
			title: 'Add Company Check Template',
		}
    },  	
    {
	    path: 'company-inspections-setting',
	    name: 'CompanyInspectionsSetting',
	    component: CompanyInspectionsSetting,
	    meta: {
	      title: 'CompanyInspectionsSetting',
	    }
  	},
  	{
	    path: 'import-excel',
	    name: 'ImportExcel',
	    component: ImportExcel,
	    meta: {
	      title: 'ImportExcel',
	    }
  	},
  	{
	    path: '',
	    name: 'Settings',
	    component: Settings,
	    meta: {
	      title: 'Settings',
	    }
  	},
    {
	    path: '/groups',
	    name: 'Groupss',
	    component: Groups,
	    meta: {
	      title: 'Groupss',
	    }
  	},
  ]
},
{
  path: '/group/print/qr-code/:Id',
  component: PrintGroupQr,
  children: [
  {
    path: '/group/print/qr-code/:Id',
    name: 'GroupQr',
    component: PrintGroupQr,
    meta: {
      title: 'Print Qr Code',
    }
  },
]
},
{
    path: '/assets',
    component: PrintQrCode,
    children: [
    {
	    path: '/assets/print/qr-code/:Id',
	    name: 'AssetsAdd',
	    component: PrintQrCode,
	    meta: {
	      title: 'Print Qr Code',
	    }
  	},
  ]
},

{
    path: '/asset-group/print/qr-code/:Id',
    component: PrintGroupQrCode,
    children: [
    {
	    path: '/asset-group/print/qr-code/:Id',
	    name: 'AssetsAdd',
	    component: PrintGroupQrCode,
	    meta: {
	      title: 'Print Qr Code',
	    }
  	},
  ]
},
{
    path: '/assets',
    component: Body,
    children: [
    {
	    path: 'add',
	    name: 'AssetsAdd',
	    component: AssetsAdd,
	    meta: {
	      title: 'Assets',
	    }
  	},	
  	{
	    path: 'category',
	    name: 'Category',
	    component: Category,
	    meta: {
	      title: 'Category',
	    }
  	},
  	{
	    path: 'location',
	    name: 'Location',
	    component: Location,
	    meta: {
	      title: 'Location',
	    }
  	},
  	{
	    path: 'group',
	    name: 'Group',
	    component: Group,
	    meta: {
	      title: 'Group',
	    }
  	},
  	{
	    path: 'ownership',
	    name: 'Ownership',
	    component: Ownership,
	    meta: {
	      title: 'Ownership',
	    }
  	},
  	{
	    path: 'list',
	    name: 'AssetsList',
	    component: AssetsList,
	    meta: {
	      title: 'Assets List',
	    }
  	},
    {
      path:'/asset/profile/:AssetId',
      name:'AssetProfile',
      component:AssetProfile,
      meta: {
        title: 'Asset Profile',
      }
    },
    {
      path:'/asset/templates',
      name:'AssetTemplates',
      component:AssetTemplates,
      meta: {
        title: 'Asset Templates',
      }
    },
     {
      path: '/asset/settings',
      name: 'AssetSettings',
      component: AssetSettings,
      meta: {
        title: 'Asset Settings',
      }
    },
    {
      path:'/asset/template/checks/:TemplateId',
      name:'AssetTemplateChecks',
      component:AssetTemplateChecks,
      meta: {
        title: 'Asset Template Checkss',
      }
    },
    {
      path:'/asset/template/add',
      name:'AddAssetTemplate',
      component:AddAssetTemplate,
      meta: {
        title: 'Asset Template Checkss',
      }
    }
  ]
},
{
  path: '/widgets',
  component: Body,
  children: [
  {
    path: 'general',
    name: 'general',
    component: GeneralWidgets,
    meta: {
      title: 'General Widgets',
    }
  },
  {
    path: 'chart',
    name: 'chart',
    component: ChartWidgets,
    meta: {
      title: 'Chart Widgets',
    }
  },
  ]
},
{
  path: '/project',
  component: Body,
  children: [
  {
    path: 'projectlist',
    name: 'project-list',
    component: projectlist,
    meta: {
      title: 'Project List',
    }
  },
  {
    path: 'create-project',
    name: 'create-project',
    component: createproject,
    meta: {
      title: 'Create Project',
    }
  }
  ]
},
{
  path: '/uikits',
  component: Body,
  children: [
  {
    path: 'alert',
    name: 'alert',
    component: alert,
    meta: {
      title: 'Alert',
    }
  },
  {
    path: 'helper-classes',
    name: 'Helperclasses',
    component: Helperclasses,
    meta: {
      title: 'Helperclasses',
    }
  },
  {
    path: 'avatars',
    name: 'Avatars',
    component: Avatars,
    meta: {
      title: 'Avatars',
    }
  },
  {
    path: 'grid',
    name: 'Grid',
    component: Grid,
    meta: {
      title: 'Grid',
    }
  },
  {
    path: 'tag-pills',
    name: 'Tagpills',
    component: Tagpills,
    meta: {
      title: 'Tagpills',
    }
  },
  {
    path: 'typography',
    name: 'Typography',
    component: Typography,
    meta: {
      title: 'Typography',
    }
  },
  {
    path: 'progress-bar',
    name: 'Progressbar',
    component: Progressbar,
    meta: {
      title: 'Progressbar',
    }
  },
  {
    path: 'modal',
    name: 'Modal',
    component: Modal,
    meta: {
      title: 'Modal',
    }
  },
  {
    path: 'popover',
    name: 'Popover',
    component: Popover,
    meta: {
      title: 'Popover',
    }
  },
  {
    path: 'tooltip',
    name: 'Tooltip',
    component: Tooltip,
    meta: {
      title: 'Tooltip',
    }
  },
  {
    path: 'loader',
    name: 'Spinners',
    component: Spinners,
    meta: {
      title: 'Spinners',
    }
  },
  {
    path: 'dropdown',
    name: 'Dropdown',
    component: Dropdown,
    meta: {
      title: 'Dropdown',
    }
  },
  {
    path: 'accordion',
    name: 'Accordion',
    component: Accordion,
    meta: {
      title: 'Accordion',
    }
  },
  {
    path: 'box-shadow',
    name: 'Boxshadow',
    component: Boxshadow,
    meta: {
      title: 'Boxshadow',
    }
  },
  {
    path: 'lists',
    name: 'Lists',
    component: Lists,
    meta: {
      title: 'Lists',
    }
  }
  ]
},
{
  path: '/advance',
  component: Body,
  children: [
  {
    path: 'scrollable',
    name: 'Scrollable',
    component: Scrollable,
    meta: {
      title: 'Scrollable',
    }
  },
  {
    path: 'sweetalert',
    name: 'Sweetalert',
    component: Sweetalert,
    meta: {
      title: 'Sweetalert',
    }
  },
  {
    path: 'tree',
    name: 'Tree',
    component: Tree,
    meta: {
      title: 'Tree',
    }
  },
  {
    path: 'rating',
    name: 'Rating',
    component: Rating,
    meta: {
      title: 'Rating',
    }
  },
  {
    path: 'pagination',
    name: 'Pagination',
    component: Pagination,
    meta: {
      title: 'Pagination',
    }
  },
  {
    path: 'ribbons',
    name: 'Ribbons',
    component: Ribbons,
    meta: {
      title: 'Ribbons',
    }
  },
  {
    path: 'tour',
    name: 'Tour',
    component: Tour,
    meta: {
      title: 'Tour',
    }
  },
  {
    path: 'range-slider',
    name: 'Rangeslider',
    component: Rangeslider,
    meta: {
      title: 'Rangeslider',
    }
  },
  {
    path: 'breadcrumb',
    name: 'Breadcrumb',
    component: Breadcrumb,
    meta: {
      title: 'Breadcrumb',
    }
  },
  {
    path: 'upload',
    name: 'Upload',
    component: Upload,
    meta: {
      title: 'Upload',
    }
  },
  {
    path: 'sticky',
    name: 'Sticky',
    component: Sticky,
    meta: {
      title: 'Sticky',
    }
  },
  {
    path: 'toastr',
    name: 'Toastr',
    component: Toastr,
    meta: {
      title: 'Toastr',
    }
  },
  {
    path: 'image-cropper',
    name: 'ImageCropper',
    component: ImageCropper,
    meta: {
      title: 'ImageCropper',
    }
  },
  {
    path: 'dragdrop',
    name: 'Draganddrop',
    component: Draganddrop,
    meta: {
      title: 'Draganddrop',
    }
  },
  ]
},
{
  path: '/chart',
  component: Body,
  children: [
  {
    path: 'google',
    name: 'Google Chart',
    component: GoogleChart,
    meta: {
      title: 'GoogleChart',
    }
  },
  {
    path: 'chartist',
    name: 'Chartist',
    component: Chartist,
    meta: {
      title: 'Chartist',
    }
  },
  {
    path: 'apexchart',
    name: 'ApexChart',
    component: ApexChart,
    meta: {
      title: 'ApexChart',
    }
  },
  ]
},
{
  path: '/gallery',
  component: Body,
  children:[
    {
      path: 'grid-gallery',
      name: 'GridGallery',
      component:GridGallery,
      meta: {
        title: 'GridGallery',
      }
    },
    {
      path: 'gallery-desc',
      name: 'GridGalleryDesc',
      component:GridGalleryDesc,
      meta: {
        title: 'GridGalleryDesc',
      }
    },
    {
      path: 'gallery-masonary',
      name: 'GalleryMasonary',
      component:GalleryMasonary,
      meta: {
        title: 'GalleryMasonary',
      }
    },
    {
      path: 'gallery-masonary-desc',
      name: 'GalleryMasonaryDesc',
      component:GalleryMasonaryDesc,

    },
    {
      path: 'hover-effect',
      name: 'HoverEffect',
      component:HoverEffect,
      meta: {
        title: 'HoverEffect',
      }
    }
  ]
},
{
  path: '/editor',
  component: Body,
  children:[
    {
      path: 'simple-editor',
      name: 'SimpleEditor',
      component:SimpleEditor,
      meta: {
        title: 'SimpleEditor',
      }
    },
    {
      path: 'ck-editor',
      name: 'CkEditor',
      component:CkEditor,
       meta: {
        title: 'CkEditor',
      }

    }
  ]
},
{
  path:'/users',
  component: Body,
  children:[
    {
      path: 'profile',
      name: 'UserProfile',
      component:UserProfile,
       meta: {
        title: 'serProfile',
      }
    },
    {
      path: 'edit',
      name: 'UserEditProfile',
      component:UserEditProfile,
       meta: {
        title: 'serEditProfile',
      }
    },
    {
      path: 'cards',
      name: 'UserCards',
      component:UserCards,
       meta: {
        title: 'serCards',
      }
    },
    {
      path:'/users',
      name:'Users',
      component:Users,
      meta: {
        title: 'Users',
        }
      },
      {
        path:'/add-user',
        name:'UserAdd',
        component:UserAdd,
        meta: {
          title: 'User Add',
        }
      },
      {
        path:'/user-update/:UserId',
        name:'UserUpdate',
        component:UserUpdate,
        meta: {
          title: 'Update User Details',
        }
      },
      {
        path:'/view-account-permissions/:UserId',
        name:'ViewAccountPermissions',
        component:ViewAccountPermissions,
        meta: {
          title: 'View Account Permissions',
        }
      }
  ]
},
{
  path:'/blog',
  component: Body,
  children:[
    {
      path: 'details',
      name: 'Blog',
      component:Blog,
       meta: {
        title: 'log',
      }
    },
    {
      path: 'single',
      name: 'BlogSingle',
      component:BlogSingle,
       meta: {
        title: 'logSingle',
      }
    }
  ]
},
{
  path:'/email-preferences',
  component: Body,
  children:[
    {
      path: '/email-preferences',
      name: 'Notifications',
      component:EmailPreferences,
       meta: {
        title: 'Account Roles',
      }
    },
  ]
},
{
  path:'/account-roles',
  component: Body,
  children:[
    {
      path: '/account-roles',
      name: 'Account Roles',
      component:AccountRoles,
       meta: {
        title: 'Account Roles',
      }
    },
    {
      path:'/add-account-role',
      name:'AccountRoleAdd',
      component:AccountRoleAdd,
      meta: {
        title: 'Account Role Add',
      }
    },
    {
      path:'/role-update/:RowId',
      name:'AccountRoleEdit',
      component:AccountRoleEdit,
      meta: {
        title: 'Account Role edit',
      }
    },{
      path:'/view-account-role/:RowId',
      name:'AccountRoleView',
      component:AccountRoleView,
      meta: {
        title: 'View Account Role',
      }
    },
  ]
},
{
  path:'/maps',
  component: Body,
  children:[
    {
      path: 'vue-google-maps',
      name: 'GoogleMaps',
      component:GoogleMaps,
       meta: {
        title: 'oogleMaps',
      }
    },
    {
      path: 'vue-leaflet-maps',
      name: 'VueLeaflet',
      component:VueLeaflet,
       meta: {
        title: 'ueLeaflet',
      }
    }
  ]
},
{
  path: '/icons',
  component: Body,
  children:[
  {
    path: 'flag',
    name: 'Flag',
    component: Flag,
     meta: {
        title: 'Flag',
      }
  },
  {
    path: 'ico',
    name: 'Ico',
    component: Ico,
     meta: {
        title: 'Ico',
      }
  },
  {
    path: 'themify',
    name: 'Themify',
    component: Themify,
     meta: {
        title: 'Themify',
      }
  },
  {
    path: 'fontawesome',
    name: 'Fontawesome',
    component: Fontawesome,
     meta: {
        title: 'Fontawesome',
      }
  },
  {
    path: 'feather_icon',
    name: 'FeatherIcon',
    component: FeatherIcon,
     meta: {
        title: 'FeatherIcon',
      }
  },
  {
    path: 'whether',
    name: 'WhetherIcon',
    component: WhetherIcon,
     meta: {
        title: 'WhetherIcon',
      }
  }
  ]
},
{
  path: '/form',
  component: Body,
  children: [
  {
    path: 'wizard',
    name: 'FormWizard',
    component: FormWizrd,
     meta: {
        title: 'FormWizrd',
      }
  },
  {
    path: 'validation',
    name: 'FormValidation',
    component: FormValidation,
     meta: {
        title: 'FormValidation',
      }
  },
  {
    path: 'inputs',
    name: 'FormBaseInputs',
    component: FormBaseInputs,
     meta: {
        title: 'FormBaseInputs',
      }
  },
  {
    path: 'checkbox-radio',
    name: 'FormCheckboxRadio',
    component: FormCheckboxRadio,
     meta: {
        title: 'FormCheckboxRadio',
      }
  },
  {
    path: 'input-groups',
    name: 'FormInputGroups',
    component: FormInputGroups,
     meta: {
        title: 'FormInputGroups',
      }
  },
  {
    path: 'mega-options',
    name: 'FormMegaOptions',
    component: FormMegaOptions,
     meta: {
        title: 'FormMegaOptions',
      }
  },
  {
    path: 'datepicker',
    name: 'FormDatepicker',
    component: FormDatepicker,
     meta: {
        title: 'FormDatepicker',
      }
  },
  {
    path: 'select2',
    name: 'FormSelect2',
    component: FormSelect2,
     meta: {
        title: 'FormSelect2',
      }
  },
  {
    path: 'switch',
    name: 'FormSwitch',
    component: FormSwitch,
     meta: {
        title: 'FormSwitch',
      }
  },
  {
    path: 'typeahead',
    name: 'FormTypeahead',
    component: FormTypeahead,
     meta: {
        title: 'FormTypeahead',
      }
  },
  {
    path: 'clipboard',
    name: 'FormClipboard',
    component: FormClipboard,
     meta: {
        title: 'FormClipboard',
      }
  },
  {
    path: 'touchspin',
    name: 'FormTouchspin',
    component: FormTouchspin,
     meta: {
        title: 'FormTouchspin',
      }
  },
  {
    path: 'mega-options',
    name: 'Form Mega Options',
    component: FormMegaOptions,
     meta: {
        title: 'FormMegaOptions',
      }
  }
  ]
},
{
  path: '/table',
  component: Body,
  children: [
  {
    path: 'basic',
    name: 'BootstrapBasic',
    component: BootstrapBasic,
     meta: {
        title: 'BootstrapBasic',
      }
  },
  {
    path: 'sizing',
    name: 'BootstrapSizing',
    component: BootstrapSizing,
     meta: {
        title: 'BootstrapSizing',
      }
  },
  {
    path: 'border',
    name: 'BootstrapBorder',
    component: BootstrapBorder,
     meta: {
        title: 'BootstrapBorder',
      }
  },
  {
    path: 'styling',
    name: 'BootstrapStyling',
    component: BootstrapStyling,
     meta: {
        title: 'BootstrapStyling',
      }
  },
  {
    path: '/datatable-basic',
    name: 'DatatableBasic',
    component: DatatableBasic,
     meta: {
        title: 'DatatableBasic',
      }
  },
  {
    path: '/datatable-select-delete',
    name: 'DatatableSelectDelete',
    component: DatatableSelectDelete,
     meta: {
        title: 'DatatableSelectDelete',
      }
  },
  {
    path: '/filter-table',
    name: 'FilterTable',
    component: FilterTable,
     meta: {
        title: 'FilterTable',
      }
  },
  {
    path: '/datatable-export',
    name: 'DatatableExport',
    component: DatatableExport,
     meta: {
        title: 'DatatableExport',
      }
  },
  {
    path: 'smarttable',
    name: 'SmartTable',
    component: SmartTable,
     meta: {
        title: 'SmartTable',
      }
  },
  ]
},
{
  path: '/buttons',
  component: Body,
  children:[
  {
    path: 'default',
    name: 'default_buttons',
    component: Default_buttons,
     meta: {
        title: 'Default_buttons',
      }
  },
  {
    path: 'flat',
    name: 'flat_buttons',
    component: Flat_buttons,
     meta: {
        title: 'Flat_buttons',
      }
  },
  {
    path: 'edge',
    name: 'edge_buttons',
    component: Edge_buttons,
     meta: {
        title: 'Edge_buttons',
      }
  },
  {
    path: 'raised',
    name: 'raised_buttons',
    component: Raised_buttons,
     meta: {
        title: 'Raised_buttons',
      }
  },
  {
    path: 'group',
    name: 'group_buttons',
    component: Group_buttons,
     meta: {
        title: 'Group_buttons',
      }
  }
  ]
},
{
  path: '/ecommerce',
  component: Body,
  children: [

  {
    path: 'product',
    name: 'Product',
    component: Products,
     meta: {
        title: 'Products',
      }
  },
  {
    path: 'details/:id',
    name: 'Product Details',
    component: ProductDetails,
     meta: {
        title: 'ProductDetails',
      }
  },
  {
    path: 'cart',
    name: 'Cart',
    component: Cart,
     meta: {
        title: 'Cart',
      }
  },
  {
    path: 'wishlist',
    name: 'Wishlist',
    component: Wishlist,
     meta: {
        title: 'Wishlist',
      }
  },
  {
    path: 'checkout',
    name: 'Checkout',
    component: Checkout,
     meta: {
        title: 'Checkout',
      }
  },
  {
    path: 'invoice',
    name: 'Invoice',
    component: Invoice,
     meta: {
        title: 'Invoice',
      }
  },
  {
    path: 'success',
    name: 'Success',
    component: Success,
     meta: {
        title: 'Success',
      }
  },
  {
    path: 'order/history',
    name: 'Order History',
    component: OrderHistory,
     meta: {
        title: 'OrderHistory',
      }
  },
  {
    path: 'payment/details',
    name: 'payment Details',
    component: PaymentDetails,
     meta: {
        title: 'PaymentDetails',
      }
  },
  ]
},
{
  path:'/cards',
  component:Body,
  children:[
  {
    path:'basic',
    name:'Basic',
    component:Basic,
    meta: {
      title: 'BootstrapStyling',
    }
  },
  {
    path:'creative',
    name:'Creative',
    component:Creative,
    meta: {
      title: 'Creative',
    }
  },
  {
    path:'tabbed',
    name:'Tabbed',
    component:Tabbed,
    meta: {
      title: 'Tabbed',
    }
  },
  {
    path:'draggable',
    name:'Draggable',
    component:Draggable,
    meta: {
      title: 'Draggable',
    }
  }
  ]
},
{
  path: '/app',
  component: Body,
  children: [
  {
    path: 'todo',
    name: 'todo',
    component: Todo,
     meta: {
        title: 'Todo',
      }
  },
  {
    path: 'firebase-todo',
    name: 'FirebaseTodo',
    component: FirebaseTodo,
     meta: {
        title: 'FirebaseTodo',
      }
  },
  {
    path: 'chat',
    name: 'chat',
    component: Chat,
     meta: {
        title: 'Chat',
      }
  },
  {
    path: 'videochat',
    name: 'Video chat',
    component: Videochat,
     meta: {
        title: 'Video Chat',
      }
  },
  {
    path: 'email',
    name: 'Email',
    component: Email,
     meta: {
        title: 'Email,',
      }
  },
  {
    path: 'filemanager',
    name: 'File Manager',
    component: FileManager,
     meta: {
        title: 'File Manager,',
      }
  },
  {
    path: 'kanban',
    name: 'Kanban Board',
    component: Kanban,
     meta: {
        title: 'Kanban Board,',
      }
  },
  {
    path:'bookmark',
    name:'Bookmark',
    component:Bookmark,
    meta: {
      title: 'Bookmark',
    }
  },
  {
    path:'calendar',
    name:'Calendar',
    component:Calendar,
    meta: {
      title: 'Calendar',
    }
  }
  ]
},
{
  path: '/timeline',
  component: Body,
  children: [
  {
    path: 'one',
    name: 'TimelineOne',
    component: TimelineOne,
     meta: {
        title: 'TimelineOne',
      }
  }
  ]
},
{
  path: '/auth',
  component: Auth,
  children: [{
    path: 'login',
    name: 'Login 1',
    component: login,
    meta: {
      title: ' login',
    }
  },
  {
    path: 'login/step-2',
    name: 'Login 2',
    component: google2FA,
    meta: {
      title: 'login step-2',
    }
  },
  {
    path: 'forgot-password',
    name: 'Forgot Password',
    component: ForgotPassword,
    meta: {
      title: 'Forgot Password',
    }
  },
  {
    path: 'register',
    name: 'register 1',
    component: Register,
    meta: {
      title: ' Register',
    }
  }
  ]
},
{
  path: '/pages',
  component: Body,
  children:[
    {
      path:'/pages/sample-page',
      name:'SamplePage',
      component:SamplePage,
      meta: {
        title: 'SamplePage',
      }
    },
    {
      path:'/pages/pricing',
      name:'Pricing',
      component:Pricing,
      meta: {
      title: 'Pricing',
    }
    }
  ]
},
{
  path: '/callback',
  name: 'callback',
  component: callback,
  meta: {
      title: 'Auth0',
  }
},
{
  path: '/pages',
  component: Body,
  children:[
    {
      path:'/pages/faq',
      name:'Faq',
      component:Faq,
      meta: {
      title: 'Faq',
    }
    },
    {
      path:'/pages/support',
      name:'Support',
      component:Support,
      meta: {
      title: 'Support',
    }
    },
    {
      path:'/pages/social-app',
      name:'Social',
      component:Social,
      meta: {
      title: 'Social',
    }
    }
  ]
},
{
  path:'/job',
  component:Body,
  children:[
    {
      path:'/job/list',
      name:'JobList',
      component:JobList,
      meta: {
      title: 'JobList',
    }
    },
    {
      path:'/job/details/:id',
      name:'JobDetails',
      component:JobDetails,
      meta: {
      title: 'JobDetails,',
    },
      props:true
    },
    {
      path:'/job/apply/:id',
      name:'JobApply',
      component:JobApply,
      meta: {
      title: 'JobApply,',
    },
      props:true
    }
  ]
},
{
  path:'/search',
  component:Body,
  children:[
    {
      path:'/pages/search',
      name:'Search',
      component:Search,
      meta: {
        title: 'Search',
      }
    }
  ]
},
{
  path:'/learning',
  component:Body,
  children:[
    {
      path:'/learning/list',
      name:'Learninglist',
      component:Learninglist,
      meta: {
        title: 'Learninglist',
      }
    },
    {
      path:'/learning/details/:id',
      name:'Coursedetailed',
      component:Coursedetailed,
      meta: {
      title: 'Coursedetailed,',
      },
      props:true
    }
  ]
},
{
  path:'/knowledgebase',
  component:Body,
  children:[
    {
      path:'/',
      name:'Knowledgebase',
      component:Knowledgebase,
      meta: {
      title: 'Knowledgebase',
    }
    }
  ]
},
{
  path:'/error-400',
  name:'Error400',
  component:Error400,
  meta: {
      title: 'Error400',
    }
},
{
  path:'/error-401',
  name:'Error401',
  component:Error401,
  meta: {
      title: 'Error401',
    }
},
{
  path:'/error-403',
  name:'Error403',
  component:Error403,
  meta: {
      title: 'Error403',
    }
},
{
  path:'/error-404',
  name:'Error404',
  component:Error404,
  meta: {
      title: 'Error404',
    }
},
{
  path:'/error-500',
  name:'Error500',
  component:Error500,
  meta: {
      title: 'Error500',
    }
},
{
  path:'/error-503',
  name:'Error503',
  component:Error503,
  meta: {
      title: 'Error503',
    }
},
{
  path:'/maintenance',
  name:'Maintenance',
  component:Maintenance,
  meta: {
      title: 'Maintenance',
    }
},
{
  path:'/comingsoon/comingsoon-simple',
  name:'ComingsoonSimple',
  component:ComingsoonSimple,
  meta: {
      title: 'ComingsoonSimple',
    }
},
{
  path:'/comingsoon/comingsoon-image',
  name:'ComingsoonImage',
  component:ComingsoonImage,
  meta: {
      title: 'ComingsoonImage',
    }
},
{
  path:'/comingsoon/comingsoon-video',
  name:'ComingsoonVideo',
  component:ComingsoonVideo,
  meta: {
      title: 'ComingsoonVideo',
    }
},
{
  path:'/authentication/login/one',
  name:'LoginOne',
  component:LoginOne,
  meta: {
      title: 'LoginOne',
    }
},
{
  path:'/authentication/login/two',
  name:'LoginTwo',
  component:LoginTwo,
  meta: {
      title: 'LoginTwo',
    }
},
{
  path:'/authentication/login/validate',
  name:'LoginValidate',
  component:LoginValidate,
  meta: {
      title: 'LoginValidate',
    }
},
{
  path:'/authentication/register/image',
  name:'RegisterImage',
  component:RegisterImage,
  meta: {
      title: 'RegisterImage',
    }
},
{
  path:'/authentication/register/image2',
  name:'RegisterImage2',
  component:RegisterImage2,
  meta: {
      title: 'RegisterImage2',
    }
},
{
  path:'/authentication/unlockuser',
  name:'Unlock',
  component:Unlock,
  meta: {
      title: 'Unlock',
    }
},
{
  path:'/authentication/forgetpassword',
  name:'ForgetPassword',
  component:ForgetPassword,
  meta: {
      title: 'ForgetPassword',
    }
},
{
  path:'/authentication/resetpassword',
  name:'ResetPassword',
  component:ResetPassword,
  meta: {
      title: 'ResetPassword',
    }
},
{
  path:'/drivers-list',
  component:Body,
  children:[
    {
      path:'/drivers-list',
      name:'Drivers',
      component:Drivers,
      meta: {
        title: 'Drivers',
        }
      },
      {
        path:'/driver-profile/:DriverId',
        name:'DriverProfile',
        component:DriverProfile,
        meta: {
          title: 'DriverProfile',
        }
      },
      {
        path:'/driver-add',
        name:'DriverAdd',
        component:DriverAdd,
        meta: {
          title: 'DriverAdd',
        }
      }
     ]
 },
 {
  path:'/vehicles-list',
  component:Body,
  children:[
    {
      path:'/vehicles-list',
      name:'Vehicles',
      component:Vehicles,
      meta: {
        title: 'Vehicles List',
      }
    }
  ]
},
 {
  path:'/update-profile',
  component:Body,
  children:[
    {
      path:'/update-profile',
      name:'Profile Update',
      component:ProfileUpdate,
      meta: {
        title: 'Profile Update',
      }
    }
  ]
},
{
  path:'/trailers-list',
  component:Body,
  children:[
    {
      path:'/trailers-list',
      name:'trailers',
      component:Trailers,
      meta: {
        title: 'Trailers List',
      }
    },
    {
      path:'/trailer-add',
      name:'trailers',
      component:TrailerAdd,
      meta: {
        title: 'Trailers Add',
      }
    },
    {
      path:'/trailer-profile/:TrailerId',
      name:'TrailerProfile',
      component:TrailerProfile,
      meta: {
        title: 'Trailer Profile',
      }
    }
  ]
},
{
  path:'/vehicle-profile/:VehicleId',
  component:Body,
  children:[
    {
      path:'/vehicle-profile/:VehicleId',
      name:'VehicleProfile',
      component:VehicleProfile,
      meta: {
        title: 'Vehicle Profile',
      }
    },
    {
      path:'/vehicle-add',
      name:'VehicleAdd',
      component:VehicleAdd,
      meta: {
        title: 'Vehicle Add',
      }
    },
    {
      path:'/vehicle-profile-checks/:VehicleId',
      name:'VehicleProfileChecks',
      component:VehicleProfileChecks,
      meta: {
        title: 'Vehicle Profile Checks',
      }
    }
  ]
},
{
  path:'/external-links',
  component:Body,
  children:[
    {
      path:'/external-links/:Type/:PageName',
      name:'External Links',
      component:ExternalLinks,
      meta: {
        title: 'External Links',
      }
    }
  ]
},
{
  path:'/company-details',
  component:Body,
  children:[
    {
      path:'/company-details',
      name:'Company Details',
      component:CompanyDetails,
      meta: {
        title: 'Company Details',
      }
    }
  ]
},
{
  path:'/branches',
  component:Body,
  children:[
    {
      path:'/branches',
      name:'Branches',
      component:Branches,
      meta: {
        title: 'Branches',
        }
      },
      {
        path:'/branch-add',
        name:'BranchAdd',
        component:BranchAdd,
        meta: {
          title: 'Branch Add',
        }
      },
      {
        path:'/branch-update/:BranchId',
        name:'BranchUpdate',
        component:BranchUpdate,
        meta: {
          title: 'Update Branch Details',
        }
      }
     ]
 },
 {
  path:'/task-add',
  component:Body,
  children:[
    {
      path:'/task-add',
      name:'TaskAdd',
      component:TaskAdd,
      meta: {
        title: 'Task Add',
        }
      },      
    ]
 },
 {
  path:'/book-repair',
  component:Body,
  children:[
    {
      path:'/book-repair',
      name:'BookRepair',
      component:BookRepair,
      meta: {
        title: 'Book Repair',
        }
      },      
    ]
 },
 {
  path:'/book-service-appointment',
  component:Body,
  children:[
    {
      path:'/book-service-appointment',
      name:'BookServiceAppointment',
      component:BookServiceAppointment,
      meta: {
        title: 'Book Service Appointment',
        }
      },      
    ]
 },
];

const router = new Router({
  routes,
  base: process.env.BASE_URL,
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {
    if(to.meta.title)
      document.title = to.meta.title;
    const CurrentUser = firebase.auth().currentUser;
    const  path = ['/auth/login','/auth/register','/auth/login/step-2','/auth/forgot-password'];
    if (path.includes(to.path) || to.path === '/callback'  || to.name === "VehicleInspectionCreate" || CurrentUser || Userauth.isAuthenticatedUser()){
      return next();
    }
    next('/auth/login');
  });
});

export default router;
